import "./SignIn.css";
import { useCallback, useState } from "react";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import { useAuth } from "../../auth/AuthContext";

export default function SignIn() {
  const { signIn } = useAuth();
  const [leaving, setLeaving] = useState(false);

  const handleSignIn = useCallback(() => {
    setLeaving(true);
    signIn();
  }, [signIn]);

  if (leaving) return <Loader />;

  return (
    <div className="signin col">
      <div className="signin-card col">
        <span className="t-eyebrow t-brand">Multipli Hackathon</span>
        <h1 className="t-h1">Admin</h1>
        <p className="t-body t-dim">
          Sign in with the Google account you mentor or administer with.
        </p>
        <Button block onClick={handleSignIn}>
          Sign in with Google
        </Button>
      </div>
    </div>
  );
}
